import React from 'react';
import { Link } from 'react-router-dom';
import './index.css';

const Tag = ({ tag }) => {
    return (
        <Link className="tag-comp-container" to={`/tag/${tag.id}`}>
            {tag.code_name}
        </Link>
    )
}

export default Tag;


// WEBPACK FOOTER //
// ./src/components/Tag/index.js